import {AgencyRepository} from "../../../repositories/AgencyRepository.ts";
import {GenerateAgencyMagicLinkRequest} from "../../entities/AgencyUser.ts";

export class LinkAgencyUserMagicLinkUseCase {
    constructor(private readonly agencyRepository: AgencyRepository) {}

    async execute(agencyId: string, uid: string, data: GenerateAgencyMagicLinkRequest): Promise<string> {
        const {link} = await this.agencyRepository.linkAgencyUserMagicLink(agencyId, uid, data)
        return link
    }
}
